<template>
    <div v-if="record">
        <div v-if="record.supper && record.supplier.length > 0">
            <strong>Supplier:</strong> {{ record.supplier.displayName }}
        </div>

        <div v-if="record.ordered_date">
            <strong>Ordered Date:</strong> {{ orderedDate }}
        </div>

        <div v-html="getCenterSummary(record)"></div>

        <div v-if="record.summary.attachments.length > 0">
            <strong>Results:</strong><br />
            <div v-for="(file, i) in record.summary.attachments" :key="file.id">
                <a v-if="file.isS3" :href="file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <a v-else :href="baseURL + file.filePath" target="_blank">{{
                    file.title
                }}</a>
                <span v-if="i != record.summary.attachments.length - 1">,</span>
            </div>
        </div>

        <div v-if="record.diagnoses.length > 0">
            <strong>Open Diagnoses:</strong>
            <template v-if="isEditable">
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                    @click="$emit('edit-diagnosis', diagnosis)"
                    class="text-primary cursor-pointer"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
            <template v-else>
                <b
                    v-for="(diagnosis, index) in record.diagnoses"
                    :key="diagnosis.id + record.id"
                >
                    {{ diagnosis.description }}
                    <span v-if="index != record.diagnoses.length - 1">,</span>
                </b>
            </template>
        </div>
        <div v-if="record.record_note && record.record_note.length > 0">
            <strong>Notes:</strong> <span v-html="record.record_note"></span>
        </div>
        <div v-else-if="record.note && record.note.length > 0">
            <strong>Notes:</strong> <span v-html="record.note"></span>
        </div>

        <div v-if="record.instruction && record.instruction.length > 0">
            <strong>Instructions:</strong> {{ record.instruction }}
        </div>
    </div>
</template>
<script>
import LAB from "@/constants/lab";

export default {
    components: {},
    props: {
        record: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            baseURL: process.env.APPS
        };
    },
    computed: {
        receivedDate() {
            return this.record.received_date
                ? this._carbonDateTimeDisplay(this.record.received_date)
                : null;
        },
        orderedDate() {
            return this.record.ordered_date
                ? this._carbonDateTimeDisplay(this.record.ordered_date)
                : null;
        },
        isEditable() {
            return (
                this.record.business &&
                this.record.business.id === this._setting.business_id
            );
        },
        isWithinValidPeriod() {
            if (
                this.record.antech_status &&
                this.record.antech_status.order_date
            ) {
                let orderDate = this._toDateTime(
                    this.record.antech_status.order_date?.date
                );

                let duration = this._now().diff(orderDate, ["days"]).toObject();
                let period = LAB.ANTECH_VALIDITY_PERIOD + 1;

                return duration && duration.days < period;
            }

            return false;
        },
        validUntil() {
            if (this.record.antech_status) {
                return this._toDateTime(
                    this.record.antech_status?.order_date?.date
                )
                    .plus({ days: 29 })
                    .toFormat(this._dateFormat);
            }

            return "";
        }
    },
    methods: {
        getCenterSummary(object) {
            let summary = "";
            var referenceId = "";
            var orderStatus = "";

            if (
                Object.keys(object.abaxis.analyzer).length > 0 &&
                object.send_to
            ) {
                if (Object.keys(object.abaxis.order).length > 0) {
                    referenceId = object.id;
                    orderStatus = "Not Sent";

                    if (object.abaxis.order.isactive) {
                        referenceId = object.abaxis.order.lab_pid;
                        orderStatus = object.abaxis.order.status
                            ? object.abaxis.order.status
                                  .replace(/-/g, " ")
                                  .toLowerCase()
                            : "Not Sent";
                        if (object.received_date) {
                            orderStatus =
                                orderStatus + " (" + this.receivedDate + ")";
                        }
                    }

                    summary +=
                        "<strong>Reference ID:</strong> " +
                        referenceId +
                        "<br/>";
                    summary +=
                        "<strong>Status:</strong> " + orderStatus + "<br/>";
                } else {
                    if (object.received_date) {
                        summary +=
                            "<strong>Received Date:</strong> " +
                            this.receivedDate +
                            "<br/>";
                    }
                }
            } else if (Object.keys(object.idexx.order).length > 0) {
                referenceId = object.id;
                orderStatus = "Not Sent";

                if (object.idexx.order.is_active) {
                    orderStatus = object.idexx.order.status;

                    if (object.idexx.order.status == "CREATED") {
                        orderStatus = "Sent";
                    }

                    referenceId = object.idexx.order.lab_pid;
                    orderStatus = orderStatus
                        ? orderStatus.replace(/-/g, " ").toLowerCase()
                        : "Not Sent";

                    orderStatus = orderStatus
                        .toLowerCase()
                        .replace(/\b[a-z]/g, function (letter) {
                            return letter.toUpperCase();
                        });

                    if (object.received_date) {
                        orderStatus =
                            orderStatus + " (" + this.receivedDate + ")";
                    }
                }

                summary +=
                    "<strong>Reference ID:</strong> " + referenceId + "<br/>";
                summary += "<strong>Status:</strong> " + orderStatus + "<br/>";
            } else if (
                object.antech_status &&
                object.antech_status?.antech_v6 &&
                object.antech_status?.source == "ANTECH"
            ) {
                if (object.received_date) {
                    summary =
                        "<strong>Received Date:</strong> " +
                        this.receivedDate +
                        "<br/>";
                }

                orderStatus = object.antech_status.status;
                let badgeStatus;
                let tooltipMsg = "";

                //check if orderStatus is null
                if (orderStatus && orderStatus != null) {
                    switch (orderStatus) {
                        case LAB.ANTECH_STATUS.SUBMITTED:
                        case LAB.ANTECH_STATUS.FINAL:
                        case LAB.ANTECH_STATUS.UPDATED:
                            badgeStatus = "success";
                            break;
                        case LAB.ANTECH_STATUS.IN_PROGRESS:
                        case LAB.ANTECH_STATUS.PARTIAL:
                            badgeStatus = "light";
                            break;
                        case LAB.ANTECH_STATUS.INC_PRE_ORDER:
                        case LAB.ANTECH_STATUS.DRAFT:
                            badgeStatus = "dark";
                            tooltipMsg = this.isWithinValidPeriod
                                ? `You have until ${this.validUntil} to complete`
                                : "This order could not be completed. You may delete this record and create a new order.";
                            break;
                        case LAB.ANTECH_STATUS.PRE_ORDER:
                            badgeStatus = "info";
                            break;
                        default:
                            badgeStatus = "secondary";
                            break;
                    }

                    summary += `<strong>Status:</strong> <span class="badge badge-${badgeStatus}" v-b-tooltip.hover title="${tooltipMsg}">${orderStatus}</span><br/>`;
                }
            } else {
                if (object.received_date) {
                    summary +=
                        "<strong>Received Date:</strong> " +
                        this.receivedDate +
                        "<br/>";
                }
            }

            return summary;
        }
    }
};
</script>
